import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { useUpdateWaadMutation } from "../../redux/services/waadService/waad.Services";
import { successToast, errorToast } from "../../Utils/toast";

function EditWaad({ data }) {
    const dispatch = useDispatch();
    const [updateWaad, { isLoading }] = useUpdateWaadMutation();

    const [formData, setFormData] = useState({
        id: data?.id,
        waad_name: "",
        waad_code: "",
        description: "",
        status: 1, // ✅ Default 1 = Active
    });

    useEffect(() => {
        if (data) {
            setFormData({
                id: data.id,
                waad_name: data.waad_name || "",
                waad_code: data.waad_code || "",
                description: data.description || "",
                // ✅ Status: 1 = Active, 0 = Inactive
                status: data.status === 1 || data.status === "1" || data.status === true ? 1 : 0,
            });
        }
    }, [data]);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.waad_name.trim()) {
            errorToast("Error", "Waad name is required");
            return;
        }

        try {
            const payload = {
                id: formData.id,
                waad_name: formData.waad_name,
                waad_code: formData.waad_code,
                description: formData.description,
                status: parseInt(formData.status), // ✅ 1 or 0
            };

            await updateWaad(payload).unwrap();
            successToast("Success", "Waad updated successfully");
            dispatch(closeModal());
            window.location.reload();
        } catch (error) {
            console.error("Update error:", error);
            errorToast("Error", error?.data?.message || "Failed to update waad");
        }
    };

    return (
        <div className="custom-modal-body">
            <form onSubmit={handleSubmit}>
                <div className="edit-form-group">
                    <label className="fw-semibold">
                        Waad Name <span className="text-danger">*</span>
                    </label>
                    <input
                        type="text"
                        name="waad_name"
                        value={formData.waad_name}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Waad Name"
                        required
                        autoFocus
                    />
                </div>

                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Waad Code</label>
                    <input
                        type="text"
                        name="waad_code"
                        value={formData.waad_code}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Waad Code"
                    />
                </div>

                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Description</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Enter Description"
                        rows="2"
                    />
                </div>

                {/* ✅ Status - 1 = Active, 0 = Inactive */}
                <div className="edit-form-group mt-3">
                    <label className="fw-semibold">Status</label>
                    <select
                        name="status"
                        value={formData.status}
                        onChange={handleChange}
                        className="form-control"
                    >
                        <option value={1}>Active</option>
                        <option value={0}>Inactive</option>
                    </select>
                </div>

                {/* BUTTONS */}
                <div className="modal-btn-group mt-4">
                    <button
                        type="button"
                        className="cancel-btn"
                        onClick={() => dispatch(closeModal())}
                    >
                        Cancel
                    </button>
                    <button
                        type="submit"
                        className="save-btn"
                        disabled={isLoading}
                    >
                        {isLoading ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" />
                                Saving...
                            </>
                        ) : (
                            "Save Changes"
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
}

export default EditWaad;